import { render, staticRenderFns } from "./JobAlertUI.vue?vue&type=template&id=394b9062&scoped=true&"
import script from "./JobAlertUI.vue?vue&type=script&lang=ts&"
export * from "./JobAlertUI.vue?vue&type=script&lang=ts&"
import style0 from "./JobAlertUI.vue?vue&type=style&index=0&id=394b9062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b9062",
  null
  
)

export default component.exports